export interface TimerEntry {
  phone: string;
  startTime: number;
}

export type TimerStatus = 'RUNNING' | 'STOPPED';

export enum TimerStatusOptions {
  running = 'RUNNING',
}
